import React from "react";
import {useLanguageForShared} from "../../../../../../../shared/utils/languages/useLanguageForShared";
import {PrescriptionTemplate} from "./PrescriptionTemplate";
import {TemplateBase} from "./TemplateBase";


export function TemplateCOX_TOC({
                                    dataForm,
                                    changeValue,
                                    errors,
                                    setData,
                                    isSubmit,
                                }) {
    const {t} = useLanguageForShared()


    return (
        <>
            <TemplateBase
                dataForm={dataForm}
                changeValue={changeValue}
                errors={errors}
                isSubmit={isSubmit}
                setData={setData}
            >
                <PrescriptionTemplate
                    dataForm={dataForm}
                    changeValue={changeValue}
                    errors={errors}
                    isSubmit={isSubmit}
                    setData={setData}
                    paramsPrescription={{title: t('prescription.template.prescriptionCOX')}}
                    type={'COX'}
                />
                <PrescriptionTemplate
                dataForm={dataForm}
                changeValue={changeValue}
                errors={errors}
                isSubmit={isSubmit}
                setData={setData}
                paramsPrescription={{hasTypeflow:true, title: t('prescription.template.prescriptionTOC')}}
                type={'TOC'}
            />
            </TemplateBase>
        </>
    );
}
